import { render } from "./InvalidSession.vue?vue&type=template&id=229caa65&scoped=true"
import script from "./InvalidSession.vue?vue&type=script&lang=js"
export * from "./InvalidSession.vue?vue&type=script&lang=js"

import "./InvalidSession.vue?vue&type=style&index=0&id=229caa65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229caa65"]])

export default __exports__